import * as React from "react";

import {Spinner} from "@ok/web/components/base/Spinner/Spinner";

import cn from "classnames";
import classes from "./ClipSkeleton.styl";


export const ClipSkeleton: React.FC = (): React.ReactElement => {
    return (
        <div className={classes["clip-skeleton"]}>
            <div className={classes["main"]}>
                <div className={classes["info"]}>
                    <div className={classes["info__user"]}>
                        <div className={cn(classes["round"], classes["__mid"])}></div>
                        <div className={cn(classes["line"], classes["__mid"])}></div>
                    </div>
                    <div className={classes["info__description"]}>
                        <div className={classes["line"]}></div>
                        <div className={classes["line"]}></div>
                    </div>
                </div>
                <div className={classes["controls__wrapper"]}>
                    <div className={classes["control"]}>
                        <div className={classes["round"]}></div>
                        <div className={classes["line"]}></div>
                    </div>
                    <div className={classes["control"]}>
                        <div className={classes["round"]}></div>
                        <div className={classes["line"]}></div>
                    </div>
                    <div className={classes["control"]}>
                        <div className={classes["round"]}></div>
                    </div>
                    <div className={classes["control"]}>
                        <div className={classes["round"]}></div>
                    </div>
                </div>
            </div>

            <Spinner className={classes["spinner"]} size={"32"}/>
        </div>
    );
};
